const mePegasusMain = {
  title: 'Ми – Пегас Армс',
  paragraphs: [
    'Українська компанія оборонних технологій. Ми створюємо багаторазові ударні БпЛА, здатні діяти автономно навіть у зоні активної дії РЕБ.',
    'Наші системи працюють в  автоматичному режимі управління, з інерційною навігацією та захищеним FHSS-зв’язком.',
    'Ми довели свою ефективність у дії — щодня допомагаючи Силам оборони України наближати перемогу.',
  ],
}
export default mePegasusMain
